module.exports = __webpack_public_path__ + "img/full1-min.fd7d3ef4.png";